module.exports = __webpack_public_path__ + "7aa52f93d467c80b96a336b293d1a66c.png";